module.exports = __webpack_public_path__ + "media/images/recruitment/products/product-4-bcc1a3735c75fb807411bb54fe130824.jpg";